<template>
  <div>
    <div class="container-nav px-0 shadow-sm float-left" :class="getCurrentProductTypeClass">
      <div class="sub-nav sub-nav-rc1 float-left">
      <template  v-for="(navItem, key) in navigationItems()" >
        <button :key="key"
        :title="navItem.itemTitle"
        tabindex="0"
        @keydown.enter.prevent.stop="goToRoute(navItem)"
        @click="goToRoute(navItem)"
        :class="navItem.buttonStyles" v-if="checkTabDispCond(navItem)">
          <span v-if="navItem.status === 'ActiveIncomplete' || navItem.status === 'InactiveIncomplete'" class="fa-stack uniform-icon-size">
            <span class="fas fa-circle fa-stack-2x" :class="iconColor(navItem)"></span>
            <span class="fas fa-exclamation fa-stack-1x" style="color:#fff"></span>
          </span>
          <span v-if="navItem.status !== 'InactiveIncomplete' && navItem.status !== 'ActiveIncomplete' && navItem.status !== 'ActiveFirstTime' && navItem.status !== 'InactiveFirstTime' && navItem.status !== 'Disabled'" class="fa-stack uniform-icon-size">
            <span class="fas fa-circle fa-stack-2x" :class="iconColor(navItem)"></span>
            <span class="fas fa-check fa-stack-1x" style="color:#fff"></span>
          </span>
          <span v-if="navItem.itemIcon" class="fa-stack uniform-icon-size">
            <span :class="iconStyles(navItem)"></span>
          </span>
          <span class="navi-btn-label">{{ navItem.label }}</span>
        </button>
      </template>
      </div>
    </div>
    <Breadcrumbs v-if="flowType ==='bundle' || flowType ==='cabundle' || flowType ==='rabundle'" :navData="pageData"></Breadcrumbs>
  </div>
</template>

<script>
/* eslint-disable */
import commonService from '../../../services/common';
import postData from '../../../services/postData';
import patchData from '../../../services/patchData';
import fetchData from '../../../services/fetchData';
import { navIcons, navStatuses } from '../../../../config/dictionaries/product-navigation';
import Breadcrumbs from "../../shared/Breadcrumbs.vue";

export default {
  props: ['pageData'],
  data() {
    return {
      currentProductType: '',
      flowType:''
    };
  },
  components: {
    Breadcrumbs
  },
  computed: {
    /**
     * check quote summary panel status and add css to move content to left
     */
    quotePanelStatus() {
      if (this.$store.getters.getQuoteSummaryStatus) {
        return true;
      } else {
        return false;
      }
    },
    getCurrentProductTypeClass() {
      let flowType = sessionStorage.getItem('flowType');
      let classAdd = this.quotePanelStatus ? 'quotesumaaryopen w-75' : 'w-100';
      return flowType === 'bundle' ? this.currentProductType + ' bundleflow ' + classAdd : this.currentProductType + ' ' + classAdd;
    },
  },
  methods: {
    /**
     * check if need to display this tab or not based on carrier selected for RC 2 flow
     */
    isPolicyBound() {
      return (this.pageData.quote_summary && this.pageData.quote_summary.quote_status === 'Bound'); // TODO: Use config values
    },
    checkTabDispCond(navItem) {   
      let currentNav = sessionStorage.getItem('currentNav');
      if (this.flowType === 'bundle' || this.flowType === 'cabundle' || this.flowType === 'rabundle') {
        if ((navItem.name === 'HOCarrierMatches' || navItem.name === 'COCarrierMatches' || navItem.name === 'RECarrierMatches') && (currentNav === 'homerc1' || currentNav === 'condorc1' ||currentNav === 'rentersrc1' || currentNav === 'autorc2')) {
          return false;
        } else if (currentNav === 'homerc2' && (navItem.section === 'RC1' || navItem.name === 'hocheckout' || navItem.name === 'hoconfirmation')) {
          return false;
        } else if (currentNav === 'homerc1' && navItem.section === 'RC2') {
          return false;
        }
        return true;
      }
      const pagename = this.pageData.page_name;
      if (navItem.name === "hodwelling") {
        if (pagename.includes("bran")) {
          return false;
        } else {
          return true;
        }
      }
      if (navItem.name === "hopolicydetails") {
        if (pagename.includes("bran")) {
          return true;
        } else {
          return false;
        }
      }
      if (this.flowType === 'bundle' && navItem.name === 'HOCarrierMatches') {
        return false;
      }
      return true;
    },
    iconColor(item) {
      return (item.isComplete ? 'icon-complete' : 'icon-incomplete');
    },
    iconStyles(item) {
      return `fas ${item.itemIcon} fa-stack-2x`;
    },
    itemIcon(item) {
      let iconClass = '';
      // Choose which icon to show, if any
      if (item.status !== 'ActiveFirstTime' &&
        item.status !== 'InactiveFirstTime' &&
        item.status !== 'Disabled') {
        iconClass = false;
      } else {
        iconClass = navIcons[item.name.toLowerCase()] ? navIcons[item.name.toLowerCase()] : null;
      }

      return iconClass;
    },
    navigationItems() {
      const navigationItems = this.pageData.tab_buttons || []; 
      navigationItems.forEach((item, i) => {        
        if(item.name=="hopolicydetails"){
          if(sessionStorage.getItem('policystatus')==null || sessionStorage.getItem('policystatus') == 'true'){
            if(this.$router.currentRoute.meta.page!=="hopolicydetails"){
              item.status = sessionStorage.getItem('frmhopolicynavstatus')!==null ? sessionStorage.getItem('frmhopolicynavstatus') : 'InactiveFirstTime';
            } else
              item.status = 'ActiveFirstTime';
            }else{
            item.status = 'Disabled';
          }
        }
       
        let itemTitle = '';
        let isComplete = false;
        let buttonStyles = '';
        let sectionGroupStyles = '';
        if (navStatuses[item.status]) {
          itemTitle = navStatuses[item.status].itemTitle ? navStatuses[item.status].itemTitle : '';
          isComplete = navStatuses[item.status].isComplete ? navStatuses[item.status].isComplete : false;
          buttonStyles = navStatuses[item.status].buttonStyles ? navStatuses[item.status].buttonStyles : '';
        }
        //just adding sam
        sectionGroupStyles = (item.section === 'RC1' ? 'section-group-rc1' : ''); // TODO: Use config values
        navigationItems[i].itemTitle = `${itemTitle} ${item.label}`;
        navigationItems[i].isComplete = isComplete;
        navigationItems[i].itemIcon = this.itemIcon(item);
        navigationItems[i].buttonStyles = `nav-item cursorBox ${buttonStyles} ${sectionGroupStyles}`;
      });
      console.log('navigationItems', navigationItems);
      return navigationItems;
    },
    goToRoute(navItem) {
      this.$store.dispatch('setStartTime');
      const currentNavLink = this.$store.getters.getNavLink;
      const session_id= this.$store.getters.getSessionID;
      const getUrl = `/pages/HORateCall2Details/${session_id}`;
      //new RC2logic start
      const pagename = navItem.name;
      const rateCall = navItem.section;
      console.log(navItem, rateCall, 'pagename at navigation', pagename);
      // new RC2logic end
      
      if(rateCall !== 'RC2')
      {
        this.$store.dispatch('setRc2NavFlowAction', false);
        sessionStorage.setItem('setRc2NavFlowAction', false);
        if (navItem.status !== 'Disabled') { // TODO: Use config values
          const requestParams = {
            url: navItem.on_click,
            data: commonService.getFormData(this.pageData),
          };
          postData.navigationFormPost(requestParams).then((response) => {
            if (response.data.Navigate) {
            // Reload the page if the from and to routes are the same so that it gets new page data.
              if (response.data.Navigate.toLowerCase() === currentNavLink.toLowerCase()) {
                this.$router.go(commonService.getRouteName(response.data.Navigate)); // TODO Fetch the page data, don't reload
              }
              this.$store.dispatch('setCurrentNav', response.data.Navigate);
              this.$router.replace(commonService.getRouteName(response.data.Navigate));
            }
          });
        }
      }
      else{
         // if(this.pageData.quote_summary && this.pageData.quote_summary.quote_status === 'Bound')
         if(!this.isPolicyBound())
         {
          let patchURL='';
          const patchAPIRC2='HORateCall2Details';
          const patchAPIRC3='HOBindCallDetails';
          const pageNameFromAPI=this.$store.getters.getPageName;
          //Checking if tab is coming from confirmation page then it should not call Patch API
          if(pageNameFromAPI.includes('HOPostBindCallDetails'))
          {
            this.$router.replace(commonService.getRouteName(`/Property/${pagename}/tp`));
            this.$store.dispatch('sethomeRc2Nav', pagename);
            sessionStorage.setItem('sethomeRc2Nav', pagename);
          }
          else{
          if (pageNameFromAPI.includes(patchAPIRC2)) 
           patchURL='/pages/HORateCall2Details/';
          else if (pageNameFromAPI.includes(patchAPIRC3)) 
           patchURL='/pages/HOBindCallDetails/';
           const requestParams = {
            url: `${patchURL}${session_id}`,
            data: commonService.getFormData(this.pageData),
          };
          patchData.navigationFormPatch(requestParams).then((response) => {
             // Reload the page if the from and to routes are the same so that it gets new page data.
              if (this.$store.getters.homeRc2Nav.page_name=== pagename) {
                this.$router.go(commonService.getRouteName(`/Property/${pagename}/tp`)); // TODO Fetch the page data, don't reload
              }
            /** trigger required RC1.5 and RC2 calls for branch * */
           const carData = JSON.parse(sessionStorage.getItem("selectedCarrierHome"));
            if(carData){
             if (this.pageData.page_name.includes("bran") && pagename === "hopolicydetails") {
              /* start for patch call for carrier*/
              let requestParams = {
              url: `/quotes/${this.$store.getters.getSessionID}/startrate1add`,
              data : {
                    "carrierId":carData.carrier_id,
                  },
                };
              patchData.patchApi(requestParams).then((response) => {
              }).catch((error) => {
              });
              fetchData.getDashboard(`/quotes/${this.$store.getters.getSessionID}/rc2`)
              .then((response) => {
              });
            }
          }
         this.$store.dispatch('setCurrentNav',getUrl);
         this.$store.dispatch('setRc2NavFlowAction', true);
         sessionStorage.setItem('setRc2NavFlowAction', true);
         this.$router.replace(commonService.getRouteName(`/Property/${pagename}/tp`));
         this.$store.dispatch('sethomeRc2Nav', pagename);
         sessionStorage.setItem('sethomeRc2Nav', pagename);
          });
          }
      } 
      else
      {
        this.$store.dispatch('setCurrentNav',getUrl);
        this.$store.dispatch('setRc2NavFlowAction', true);
        sessionStorage.setItem('setRc2NavFlowAction', true);
        this.$router.replace(commonService.getRouteName(`/Property/${pagename}/tp`));
        this.$store.dispatch('sethomeRc2Nav', pagename);
        sessionStorage.setItem('sethomeRc2Nav', pagename);
      }
     
    
      }
    },
  },
  created() {
    this.flowType = sessionStorage.getItem('flowType');
    // this searches for the productType property amongst the route array elements to determine the current product type.
    for (let i = this.$route.matched.length - 1; i >= 0; i -= 1) {
      if (this.$route.matched[i].meta && this.$route.matched[i].meta.productType) {
        this.currentProductType = this.$route.matched[i].meta.productType;
        return;
      }
    }
  },
};
</script>

<style scoped lang="scss">
  .uniform-icon-size {
    font-size: .75rem;
  }

  div.container-nav, div.container-nav.auto {
    color: #FFF;
    background: #FFF;
  }
  div.container-nav.home {
    color: #FFF;
    background: $var-home-bg;
  }
  div.container-nav.condo {
    color: #FFF;
    background: $var-color-condo-nav-bg;
  }
  div.container-nav.renters {
    color: #FFF;
    background:$var-renter-bg;
  }
  div.container-nav.auto.bundleflow, div.container-nav.home.bundleflow {
    color: #FFF;
    background: $var-home-auto-bundle-bg;
  }

  /* Default button colors */
  div.container-nav.auto button {
    color: #333399;
  }
  div.container-nav.home button {
    color: $var-color-home-icon;
  }
  div.container-nav.condo button {
    color: $var-condo-header-icon;
  }
  div.container-nav.renters button {
    color: $var-renter-section;
  }
  div.container-nav.home.bundleflow button,
  div.container-nav.auto.bundleflow button {
    color: $var-color-home-auto-bundle-icon;
  }

  .sub-nav{
    display: inline-flex;
    font-size: 0.625rem;
  }

  /* Default nav item style (light w/ dark text) */
  .sub-nav .nav-item {
    padding: 0.75em 1.5em;
    border: none;
    display: inline-block;
  }

  /* RC1 nav item style (tinted w/ dark text) */
  .auto .sub-nav .nav-item.section-group-rc1 {
    background: #ebebff;
  }

  /* Default nav item ACTIVE style (dark w/ light text) */
  /* Default nav item HOVER style (dark w/ light text) */
  .auto .sub-nav .nav-item.activeTab,
  .auto .sub-nav .nav-item:hover {
    background: #333399;
    color: #fff;
  }

  /* Default nav item DISABLED style (light w/ light text) */
  .auto .sub-nav .nav-item.disabled,
  .auto .sub-nav .nav-item.disabled:hover {
    background: none !important;
    color: #BBBBBB;
    cursor: default !important;
  }

  /* Home nav item style (tinted w/ dark text) */
  .home .sub-nav .nav-item.section-group-rc1 {
    background: $var-home-bg;
  }
  .home .sub-nav .nav-item {
    background: $var-home-bg;
  }

  /* Home nav item ACTIVE style (dark w/ light text) */
  /* Home nav item HOVER style (dark w/ light text) */
  .home .sub-nav .nav-item.activeTab,
  .home .sub-nav .nav-item:hover {
    background: $var-color-home;
    color: $var-color-qs-white;
  }
  /* TODO: Possible to consolidate all these styles with the other products - duplicate css */
  /* Home nav item DISABLED style (light w/ light text) */
  .home .sub-nav .nav-item.disabled,
  .home .sub-nav .nav-item.disabled:hover {
    background: none !important;
    color: $var-color-home-icon-disabled !important;
    cursor: default !important;
    pointer-events: none;

  }

  /* Condo nav item style (tinted w/ dark text) */
  .condo .sub-nav .nav-item.section-group-rc1 {
    background: $var-color-condo-nav-bg;
  }

  /* Condo nav item ACTIVE style (dark w/ light text) */
  /* Condo nav item HOVER style (dark w/ light text) */
  .condo .sub-nav .nav-item.activeTab,
  .condo .sub-nav .nav-item:hover {
    background: $var-color-condo;
    color: #fff;
  }

  /* Condo nav item DISABLED style (light w/ light text) */
  .condo .sub-nav .nav-item.disabled,
  .condo .sub-nav .nav-item.disabled:hover {
    background: none !important;
    color: $var-color-condo-icon-disabled !important;
    cursor: default !important;
  }

  /* Renters nav item style (tinted w/ dark text) */
  .renters .sub-nav .nav-item.section-group-rc1 {
    background: $var-renter-bg;
  }

  /* Renters nav item ACTIVE style (dark w/ light text) */
  /* Renters nav item HOVER style (dark w/ light text) */
  .renters .sub-nav .nav-item.activeTab,
  .renters .sub-nav .nav-item:hover {
    background: $var-color-renter;
    color: #fff !important;
  }
  /* Renters nav item DISABLED style (light w/ light text) */
  .renters .sub-nav .nav-item.disabled,.renters .sub-nav .nav-item.disabled:hover
  {
    background: none;
    color: $var-renter-lighter-color !important;
    cursor: default !important;
  }
  
  /* Bundle nav item style (tinted w/ dark text) */
  .home.bundleflow .sub-nav .nav-item.section-group-rc1,
  .auto.bundleflow .sub-nav .nav-item.section-group-rc1 {
    background: $var-home-auto-bundle-bg;
  }
  .home.bundleflow .sub-nav .nav-item,
  .auto.bundleflow .sub-nav .nav-item {
    background: $var-home-auto-bundle-bg;
  }

  /* Bundle nav item ACTIVE style (dark w/ light text) */
  /* Bundle nav item HOVER style (dark w/ light text) */
  .home.bundleflow .sub-nav .nav-item.activeTab,
  .auto.bundleflow .sub-nav .nav-item.activeTab,
  .home.bundleflow .sub-nav .nav-item:hover,
  .auto.bundleflow .sub-nav .nav-item:hover {
    background: $var-color-home-auto-bundle;
    color: $var-color-qs-white;
  }
  /* Bundle nav item DISABLED style (light w/ light text) */
  .home.bundleflow .sub-nav .nav-item.disabled,
  .auto.bundleflow .sub-nav .nav-item.disabled,
  .home.bundleflow .sub-nav .nav-item.disabled:hover,
  .auto.bundleflow .sub-nav .nav-item.disabled:hover {
    background: none !important;
    color: $var-color-home-icon-disabled !important;//TODO:check for bundle flow
    cursor: default !important;
  }

  /***fontawesome stack-2x overide***/
  .fa-stack{
    height: 1.625em;
    width: 2.0em;
    line-height: 1.625em;
  }

  .fa-stack-2x{
    font-size: 1.5em;
  }

  span.navi-btn-label {
    position: relative;
    margin-left: 2px;
    display: inline-block;
  }
  .quotesumaaryopen.w-75 {
    width: 75%;
    -webkit-transition: width 500ms;
    transition: width 500ms;
  }

  /***navigation breakpoints***/
  @media all and (max-width: 1372px) {
    .sub-nav-rc1, .sub-nav-rc2 {
      width: 100%;
    }
  }
  @media all and (min-width: 1371px) {
    .container-nav {
      background: FFFFFF;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/presentational/widgets/SectionNavigation.vue?3212f8c6